import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import Avatar from 'components/Avatar';
import Switch from '@material-ui/core/Switch';
import { SPEED_DATING_MEETING } from 'constants/types';
import { SpeedDatingCardWrapper } from './styles';


function SpeedDatingSmallCard(props) {
  const {
    literals, onMouseDown, classesStr, data, color, history, footer,
    enableItemFromSerendipity, disableItemFromSerendipity, itemsPreferencesFromSerendipity,
  } = props;

  const [enabled, setEnabled] = useState(!_.find(itemsPreferencesFromSerendipity, item => item.element_type === SPEED_DATING_MEETING && item.element_id === data.id && !item.enabled));

  const [timeClick, setTimeClick] = useState(null);

  const handleClick = (event) => {
    const diff = moment().valueOf() - timeClick;
    if (diff < 200 && !window.$(event.target).hasClass('MuiSwitch-input')) {
      history.push(`/zoom-meeting/${data.zoom_id}`);
    }
  };

  const handleMouseDown = () => {
    setTimeClick(moment().valueOf());
    if (onMouseDown) {
      onMouseDown();
    }
  };

  const handleChangeEnabled = () => {
    if (!enabled) {
      enableItemFromSerendipity(SPEED_DATING_MEETING, data.id);
    } else {
      disableItemFromSerendipity(SPEED_DATING_MEETING, data.id);
    }

    setEnabled(!enabled);
  };

  return (
    <SpeedDatingCardWrapper className={classesStr} onClick={handleClick} onMouseDown={handleMouseDown}>
      <div className='header'>
        <div className='section_name' style={{ color }}>{literals.meeting}</div>
        <div className='title'>{literals.speedDating}</div>
      </div>
      <div className='banner_speed_dating' style={{ backgroundColor: color }}>
        {moment(data.start_date, 'X').format('MMMM DD,YYYY HH:mm')}
      </div>
      <div className='description'>
        <div className='user_img'>
          <Avatar size={18} avatar={data.avatar} firstname={data.firstname} id={data.id} />
        </div>
        <div className='user_data'>{`${data.firstname} ${data.lastname}`}</div>
      </div>
      <div className='footer'>
        {footer ? (
          <div>
            <Switch
              checked={enabled}
              size='small'
              onChange={handleChangeEnabled}
              name='check_enabled'
              color='primary'
            />
          </div>
        ) : null}
      </div>
    </SpeedDatingCardWrapper>
  );
}

SpeedDatingSmallCard.propTypes = {
  literals: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  classesStr: PropTypes.string,
  onMouseDown: PropTypes.func,
  footer: PropTypes.bool,
};

SpeedDatingSmallCard.defaultProps = {
  classesStr: '',
  onMouseDown: null,
  footer: false,
};

export default SpeedDatingSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/SpeedDatingSmallCard/components/index.jsx